// src/components/HeroDoorloopje.js
// Brede hero-visual (formaat van de oude video): een doorloopje als
// zigzag van hexagons (clusterbouwer-stijl). Klik → inloggen/registreren.
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;
const FEATURED_SLUG = 'laat-iedereen-nadenken';

function HeroDoorloopje({ onLoginClick, fallback }) {
  const [doorloopje, setDoorloopje] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(
        `${STRAPI_URL}/api/doorloopjes?filters[slug][$eq]=${FEATURED_SLUG}` +
          `&fields[0]=title&populate[steps][populate][image]=true`
      )
      .then((r) => {
        if (cancelled) return;
        const d = r.data?.data?.[0];
        if (d?.steps?.length) setDoorloopje(d);
        else setFailed(true);
      })
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
    };
  }, []);

  if (failed) return fallback || null;
  if (!doorloopje) return <div className="hero-doorloopje hero-doorloopje-loading" />;

  const steps = doorloopje.steps.slice(0, 5);
  const handleClick = () =>
    onLoginClick && onLoginClick('/dashboard', 'Maak gratis een account aan om dit doorloopje te bekijken.');

  return (
    <div
      className="hero-doorloopje"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      aria-label={`Bekijk het doorloopje ${doorloopje.title}`}
    >
      <div className="hero-dl-head">
        <span className="hero-dl-chip">Doorloopje</span>
        <span className="hero-dl-title">{doorloopje.title}</span>
      </div>
      <div className="hero-dl-hexrow">
        {steps.map((s, i) => (
          <div
            key={s.id || i}
            className={`hero-hex ${i % 2 === 1 ? 'hero-hex-low' : ''}`}
            style={{ left: `${i * 18.5}%` }}
          >
            <div className="hero-hex-bg">
              {s.image?.url && (
                <img className="hero-hex-img" src={s.image.url} alt={s.title || `Stap ${i + 1}`} />
              )}
            </div>
            <span className="hero-hex-num">{i + 1}</span>
          </div>
        ))}
      </div>
      <span className="hero-dl-cta">Bekijk dit doorloopje →</span>
    </div>
  );
}

export default HeroDoorloopje;
